<template>
    <div class="names-container">
        <!-- SearchBar -->
        <div class="search-section">
            <el-row :gutter="10" class="search-row">
                <el-col :span="8">
                    <el-input 
                        placeholder="Search Name" 
                        v-model="searchTip.name" 
                        @clear="handleSearch()"
                        @keyup.enter.native="handleSearch()"
                        clearable
                        size="medium">
                        <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="5">
                    <el-input 
                        placeholder="Search Tag" 
                        v-model="searchTip.tag" 
                        @clear="handleSearch()"
                        @keyup.enter.native="handleSearch()"
                        clearable
                        size="medium">
                        <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="5">
                    <el-input 
                        placeholder="Search Origin" 
                        v-model="searchTip.origin" 
                        @clear="handleSearch()"
                        @keyup.enter.native="handleSearch()"
                        clearable
                        size="medium">
                        <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="default" @click="resetSearch()" size="medium">重置</el-button>
                </el-col>
            </el-row>
            
            <el-row :gutter="10">
                <el-col :span="4">
                    <el-select v-model="searchTip.gender" placeholder="性别" @change="handleSearch()" clearable size="medium">
                        <el-option label="Male" value="male"></el-option>
                        <el-option label="Female" value="female"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="searchTip.is_member_only" placeholder="会员可见" @change="handleSearch()" clearable size="medium">
                        <el-option label="仅会员可见" :value="1"></el-option>
                        <el-option label="仅普通可见" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="searchTip.is_hidden" placeholder="隐藏状态" @change="handleSearch()" clearable size="medium">
                        <el-option label="已隐藏" :value="1"></el-option>
                        <el-option label="未隐藏" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="searchTip.has_checked" placeholder="核实状态" @change="handleSearch()" clearable size="medium">
                        <el-option label="已核实" :value="1"></el-option>
                        <el-option label="未核实" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <el-button type="primary" @click="adding" size="medium">
                        <i class="el-icon-plus"></i> 新增
                    </el-button>
                    <el-button v-if="multipleSelection.length > 0"
                        type="warning" 
                        @click="showBatchDialog = true" 
                        size="medium">
                        <i class="el-icon-setting"></i> 批量操作 ({{ multipleSelection.length }})
                    </el-button>
                </el-col>
            </el-row>
        </div>

        <!-- Table -->
        <div class="table-container">
            <el-table 
                :data="nameList" 
                border 
                stripe
                class="custom-table"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column type="expand" width="40">
                    <template slot-scope="scope">
                        <div class="expand-content">
                            <el-card class="expand-card">
                                <div class="expand-title">
                                    <span class="expand-title-bar"></span>
                                    <span>Info</span>
                                </div>
                                <el-descriptions :column="3" size="medium" border>
                                    <el-descriptions-item label="描述" :span="3">
                                        <div class="rtl-text">{{ scope.row.name_desc || '-' }}</div>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="含义" :span="3">
                                        <div class="rtl-text">{{ scope.row.name_meaning || '-' }}</div>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="ID">
                                        {{ scope.row.id || '-' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="创建时间">
                                        {{ scope.row.created_at || '-' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="更新时间">
                                        {{ scope.row.updated_at || '-' }}
                                    </el-descriptions-item>
                                </el-descriptions>
                            </el-card>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column type="index" label="#" width="40" align="center"></el-table-column>
                <el-table-column prop="name_uyghur" label="Uyghur" :align="'center'">
                    <template slot-scope="scope">
                        <div class="ugText">{{ scope.row.name_uyghur }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="name_chinese" label="Chinese" align="center"></el-table-column>
                <el-table-column prop="name_latin" label="Latin" align="center"></el-table-column>
                <el-table-column prop="gender" label="性别" width="70" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="genderTagType(scope.row.gender)" size="small" disable-transitions>{{ scope.row.gender === 'male' ? '男' : scope.row.gender === 'female' ? '女' : scope.row.gender }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="origin" label="Origin" align="center"></el-table-column>
                <el-table-column prop="tag" label="Tag" align="center"></el-table-column>
                <el-table-column prop="view_count" label="被查看" align="center"></el-table-column>
                <el-table-column label="会员可见" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag 
                            :type="scope.row.is_member_only ? 'warning' : 'info'" 
                            disable-transitions
                            size="small">
                            <i v-if="scope.row.is_member_only" class="el-icon-lock"></i>
                            <i v-else class="el-icon-unlock"></i>
                            {{ scope.row.is_member_only ? '会员专享' : '普通可见' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="隐藏状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag 
                            :type="scope.row.is_hidden ? 'danger' : 'success'" 
                            disable-transitions
                            size="small">
                            <i v-if="scope.row.is_hidden" class="el-icon-remove"></i>
                            <i v-else class="el-icon-view"></i>
                            {{ scope.row.is_hidden ? '已隐藏' : '显示中' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="核实状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag 
                            :type="scope.row.has_checked ? 'success' : 'danger'" 
                            disable-transitions
                            size="small">
                            <i v-if="scope.row.has_checked" class="el-icon-star-on"></i>
                            <i v-else class="el-icon-star-off"></i>
                            {{ scope.row.has_checked ? '已核实' : '未核实' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" size="small" @click="editing(scope.row)">
                            <i class="el-icon-edit"></i> 编辑
                        </el-button>
                        <el-popconfirm 
                            class="ml-5" 
                            confirm-button-text='确定' 
                            cancel-button-text='我再想想' 
                            icon="el-icon-info" 
                            icon-color="red" 
                            title="确定删除？" 
                            @confirm="deleting(scope.row.id)">
                            <el-button type="danger" size="small" slot="reference">
                                <i class="el-icon-remove-outline"></i> 删除
                            </el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            
            <!-- Pagination -->
            <div class="pagination-container">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        
        <!-- Edit Dialog -->
        <el-dialog 
            title="名字管理" 
            :visible.sync="dialogFormVisible" 
            :width="'40%'"
            :fullscreen="false"
            :close-on-click-modal="false">
            <el-form label-width="90px" size="small" class="edit-form">
                <el-row :gutter="15">
                    <el-col :span="12" :xs="24">
                        <el-form-item label="Uyghur">
                            <el-input v-model="form.name_uyghur" placeholder="e.g. ئىسىم" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :xs="24">
                        <el-form-item label="Chinese">
                            <el-input v-model="form.name_chinese" placeholder="例如：名字" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :xs="24">
                        <el-form-item label="Latin">
                            <el-input v-model="form.name_latin" placeholder="e.g. Name" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :xs="24">
                        <el-form-item label="Gender">
                            <el-select v-model="form.gender" placeholder="Select" clearable>
                                <el-option label="Male" value="male"></el-option>
                                <el-option label="Female" value="female"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Meaning">
                            <el-input v-model="form.name_meaning" type="textarea" :rows="3" placeholder="Name meaning" class="rtl-textarea"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Description">
                            <el-input v-model="form.name_desc" type="textarea" :rows="3" placeholder="Brief description" class="rtl-textarea"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :xs="24">
                        <el-form-item label="Origin">
                            <el-select v-model="form.origin" placeholder="请选择Origin" clearable filterable>
                                <el-option 
                                    v-for="item in originList" 
                                    :key="item.id" 
                                    :label="item.name" 
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :xs="24">
                        <el-form-item label="Tag">
                            <el-select v-model="form.tag" placeholder="请选择Tag" clearable filterable>
                                <el-option 
                                    v-for="item in tagList" 
                                    :key="item.id" 
                                    :label="item.name" 
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :xs="24">
                        <el-form-item label="Visible">
                            <el-switch
                                v-model="form.is_member_only"
                                active-text="会员"
                                inactive-text="普通"
                                :active-value="true"
                                :inactive-value="false">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :xs="24">
                        <el-form-item label="Hidden">
                            <el-switch
                                v-model="form.is_hidden"
                                active-text="隐藏"
                                inactive-text="显示"
                                :active-value="true"
                                :inactive-value="false">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :xs="24">
                        <el-form-item label="Checked">
                            <el-switch
                                v-model="form.has_checked"
                                active-text="已核实"
                                inactive-text="未核实"
                                :active-value="true"
                                :inactive-value="false">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editCancel">取 消</el-button>
                <el-button type="primary" @click="editDone">确 定</el-button>
            </div>
        </el-dialog>

        <!-- Batch Operation Dialog -->
        <el-dialog 
            title="批量操作" 
            :visible.sync="showBatchDialog" 
            :width="'30%'"
            :close-on-click-modal="false">
            <el-form label-width="120px" size="small">
                <el-form-item label="会员可见">
                    <el-switch
                        v-model="batchForm.is_member_only"
                        active-text="会员可见"
                        inactive-text="普通可见"
                        :active-value="true"
                        :inactive-value="false">
                    </el-switch>
                </el-form-item>
                <el-form-item label="隐藏状态">
                    <el-switch
                        v-model="batchForm.is_hidden"
                        active-text="隐藏"
                        inactive-text="显示"
                        :active-value="true"
                        :inactive-value="false">
                    </el-switch>
                </el-form-item>
                <el-form-item label="核实状态">
                    <el-switch
                        v-model="batchForm.has_checked"
                        active-text="批准"
                        inactive-text="驳回"
                        :active-value="true"
                        :inactive-value="false">
                    </el-switch>
                </el-form-item>
                <el-alert
                    :title="`将更新 ${multipleSelection.length} 条记录`"
                    type="info"
                    :closable="false">
                </el-alert>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showBatchDialog = false">取 消</el-button>
                <el-button type="primary" @click="batchUpdate">确 定</el-button>
            </div>
        </el-dialog>
    </div>
    
</template>

<script>
import { formatDateTime } from '@/utils/timeUtil';

export default {
    name: 'Names',
    data() {
        return {
            nameList: [],
            originList: [],
            tagList: [],
            dialogFormVisible: false,
            form: {},
            // 用来区分当前是“新增”还是“编辑”
            isEditing: false,
            searchTip: { 
                name: '', 
                gender: '', 
                tag: '', 
                origin: '',
                is_member_only: '', 
                is_hidden: '',
                has_checked: ''
            },
            multipleSelection: [],
            showBatchDialog: false,
            batchForm: {
                is_member_only: false,
                is_hidden: false,
                has_checked: false
            },
            currentPage: 1,
            pageSize: 20,
            total: 0
        }
    },
    created() {
        this.getNames()
        this.getOrigins()
        this.getTags()
    },
    beforeDestroy() {
    },
    methods: {
        genderTagType(gender){
            if(!gender) return 'info'
            const g = String(gender).toLowerCase()
            if(g === 'male' || g === 'm') return 'primary'
            if(g === 'female' || g === 'f') return 'danger'
            return 'success'
        },
        handleSearch() {
            this.currentPage = 1
            this.getNames()
        },
        resetSearch() {
            this.searchTip = { 
                name: '', 
                gender: '', 
                tag: '', 
                origin: '',
                is_member_only: '', 
                is_hidden: '',
                has_checked: ''
            }
            this.currentPage = 1
            this.getNames()
        },
        getNames(){
            // 构建查询参数，过滤空值
            const params = {
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }
            if (this.searchTip.name) params.name = this.searchTip.name
            if (this.searchTip.gender) params.gender = this.searchTip.gender
            if (this.searchTip.tag) params.tag = this.searchTip.tag
            if (this.searchTip.origin) params.origin = this.searchTip.origin
            if (this.searchTip.is_member_only !== '') params.is_member_only = this.searchTip.is_member_only
            if (this.searchTip.is_hidden !== '') params.is_hidden = this.searchTip.is_hidden
            if (this.searchTip.has_checked !== '') params.has_checked = this.searchTip.has_checked

            this.request.get('/namzar/admin/names', { params }).then(res =>{
                const list = Array.isArray(res?.nameList)
                    ? res.nameList
                    : (Array.isArray(res) ? res : (res?.data || []))
                this.nameList = list.map(item => ({
                    id: item.id,
                    name_uyghur: item.name_uyghur || '',
                    name_chinese: item.name_chinese || '',
                    name_latin: item.name_latin || '',
                    name_meaning: item.name_meaning || '',
                    name_desc: item.name_desc || '',
                    tag: item.tag || '',
                    origin: item.origin || '',
                    gender: item.gender || '',
                    is_member_only: item.is_member_only === 1 || item.is_member_only === true || false,
                    is_hidden: item.is_hidden === 1 || item.is_hidden === true || false,
                    has_checked: item.has_checked === 1 || item.has_checked === true || false,
                    view_count: item.view_count || 0,
                    created_at: item.created_at ? formatDateTime(item.created_at) : '',
                    updated_at: item.updated_at ? formatDateTime(item.updated_at) : '',
                }))
                // 处理分页信息
                this.total = res?.total || res?.count || list.length
            }).catch(res => {
                this.$message.error(res?.message || '获取数据失败')
            })
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.getNames()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getNames()
        },
        getOrigins(){
            this.request.get('/namzar/admin/origins').then(res => {
                if (res.code === 200) {
                    this.originList = Array.isArray(res.data) ? res.data : []
                }
            }).catch(res => {
                // 静默失败，不影响主流程
                console.error('获取Origin列表失败:', res?.message)
            })
        },
        getTags(){
            this.request.get('/namzar/admin/tags').then(res => {
                if (res.code === 200) {
                    this.tagList = Array.isArray(res.data) ? res.data : []
                }
            }).catch(res => {
                // 静默失败，不影响主流程
                console.error('获取Tag列表失败:', res?.message)
            })
        },
        adding(){
            this.form = {
                is_member_only: false,
                is_hidden: false,
                has_checked: false
            }
            // 新增模式
            this.isEditing = false
            this.dialogFormVisible = true
        },
        editing(row){
            this.form = { 
                ...row,
                is_member_only: row.is_member_only === 1 || row.is_member_only === true || false,
                is_hidden: row.is_hidden === 1 || row.is_hidden === true || false,
                has_checked: row.has_checked === 1 || row.has_checked === true || false
            }
            // 编辑模式
            this.isEditing = true
            this.dialogFormVisible = true
        },
        editDone(){
            // 构建提交数据，确保包含所有必要字段
            const submitData = {
                ...this.form,
                is_member_only: this.form.is_member_only === true || this.form.is_member_only === 1,
                is_hidden: this.form.is_hidden === true || this.form.is_hidden === 1,
                has_checked: this.form.has_checked === true || this.form.has_checked === 1
            }
            
            // 如果是编辑，需要包含id
            if (this.form.id) {
                submitData.id = this.form.id
            }
            
            // 根据当前模式选择不同的接口
            const url = this.isEditing 
                ? '/namzar/admin/names/edit' 
                : '/namzar/admin/names/add'

            this.request.post(url, submitData).then(res => {
                if (res) {
                    this.$message.success('保存成功')
                    this.dialogFormVisible = false
                    this.getNames()
                } else {
                    this.$message.error('保存失败')
                }
            }).catch(res => {
                this.$message.error(res?.message || '保存失败')
            })
        },
        editCancel(){
            this.dialogFormVisible = false
        },
        deleting(id){
            if (!id) {
                this.$message.error('缺少ID，无法删除')
                return
            }
            this.request.delete('/namzar/admin/names/delete/' + id).then(res => {
                if (res) {
                    this.$message.success('删除成功')
                    this.getNames()
                } else {
                    this.$message.error('删除失败')
                }
            }).catch(res => {
                this.$message.error(res?.message || '删除失败')
            })
        },
        handleSelectionChange(selection) {
            this.multipleSelection = selection
        },
        batchUpdate() {
            if (this.multipleSelection.length === 0) {
                this.$message.warning('请先选择要操作的记录')
                return
            }

            const promises = this.multipleSelection.map(item => {
                const submitData = {
                    id: item.id,
                    name_uyghur: item.name_uyghur,
                    name_chinese: item.name_chinese,
                    name_latin: item.name_latin,
                    name_meaning: item.name_meaning || '',
                    name_desc: item.name_desc || '',
                    origin: item.origin || '',
                    tag: item.tag || '',
                    gender: item.gender,
                    is_member_only: this.batchForm.is_member_only,
                    is_hidden: this.batchForm.is_hidden,
                    has_checked: this.batchForm.has_checked
                }
                return this.request.post('/namzar/admin/names/edit', submitData)
            })

            Promise.all(promises).then(results => {
                const successCount = results.filter(r => r === true).length
                if (successCount === this.multipleSelection.length) {
                    this.$message.success(`成功更新 ${successCount} 条记录`)
                    this.showBatchDialog = false
                    this.multipleSelection = []
                    this.getNames()
                } else {
                    this.$message.warning(`部分更新成功：${successCount}/${this.multipleSelection.length}`)
                    this.getNames()
                }
            }).catch(res => {
                this.$message.error(res?.message || '批量更新失败')
            })
        }
    },
}
</script>

<style scoped>
.names-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.search-section {
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    margin-bottom: 20px;
}

.search-row {
    margin-bottom: 10px;
}

.table-container {
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow-x: auto;
}

.custom-table {
    border-radius: 8px;
    overflow: hidden;
    min-width: 800px;
}

.custom-table ::v-deep .el-table__header-wrapper {
    background-color: #f5f7fa;
}

.custom-table ::v-deep .el-table__header th {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
}

.expand-content {
    padding: 12px 20px;
}

.expand-card {
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
    border: 1px solid #e0e0e0 !important;
}

.expand-title {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 16px;
    color: #333;
    letter-spacing: 1px;
}

.expand-title-bar {
    display: inline-block;
    width: 3px;
    height: 16px;
    background: #409EFF;
    border-radius: 2px;
    margin-right: 10px;
}

.ugText {
    direction: rtl;
}

/* RTL 文本样式 */
.rtl-text {
    direction: rtl;
    text-align: right;
    unicode-bidi: bidi-override;
}

/* RTL 文本域样式 */
.rtl-textarea ::v-deep .el-textarea__inner {
    direction: rtl;
    text-align: right;
    unicode-bidi: bidi-override;
}

.pagination-container {
    margin-top: 20px;
    text-align: center;
}

.pagination-container ::v-deep .el-pagination {
    white-space: nowrap;
    padding: 2px 5px;
    font-weight: 400;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 5px;
}
</style>
